import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import ErrorLogsList from "../../components/ErrorLogsManagementComponents/ErrorLogsList/ErrorLogsList";
import { ORDER, PAGE_NUMBER_OPTIONS } from "../../config";
import DataSvc from "../../services/dataSvc";
import "./styles.scss";

const defaultFilterFormData = {
  searchName: "",
  sort: "id",
  order: ORDER.DESC,
  numberPerPage: PAGE_NUMBER_OPTIONS[0],
  pageIndex: 1,
};

const ErrorLogsManagementPage: React.FC = () => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`errorLogsManagementPage.${key}`);

  const [filterFormData, setFilterFormData] = useState<any>(
    defaultFilterFormData
  );

  const { data: errorLogs } = useQuery(["error-logs", filterFormData], () =>
    DataSvc.getErrorLogs({
      offset: (filterFormData.pageIndex - 1) * filterFormData.numberPerPage,
      limit: filterFormData.numberPerPage,
      seek_total_count: true,
      keyword: filterFormData.searchName,
      sort: filterFormData.sort,
      order: filterFormData.order,
    })
  );

  return (
    <>
      <div className="right-content error-logs-management">
        <div className="top-title-bar flex-grid">
          <div className="left-title">{t("title")}</div>

          <div className="line"></div>
        </div>
        <div className="white-border-panel">
          <ErrorLogsList
            errorLogs={errorLogs?.data || []}
            filterFormData={filterFormData}
            totalCount={errorLogs?.count || 0}
            onChangeFilterFormData={setFilterFormData}
          />
        </div>
      </div>
    </>
  );
};

export default ErrorLogsManagementPage;
